import ru from 'apexcharts/dist/locales/ru.json';
import { UI_COLORLS } from '@/constants';

const basicSettings = (color1 = UI_COLORLS.bluePrimary, color2 = '#ffc726') => ({
  chart: {
    locales:       [ru],
    defaultLocale: 'ru',
    toolbar:       { show: false },
    dropShadow:    {
      enabled: true,
      top:     5,
      left:    0,
      blur:    3,
      opacity: 0.10,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve:     'smooth',
    dashArray: [0, 8],
    width:     [4, 2],
  },
  grid: {
    borderColor: '#ededed',
  },
  legend: {
    show: false,
  },
  colors: [color1, color2],
  fill:   {
    type:     'gradient',
    gradient: {
      shade:            'dark',
      inverseColors:    false,
      gradientToColors: [color1, color2],
      shadeIntensity:   1,
      type:             'horizontal',
      opacityFrom:      1,
      opacityTo:        1,
      stops:            [97, 3],
    },
  },
  markers: {
    size:   5,
    colors: color1,
  },
  xaxis: {
    type:   'datetime',
    labels: {
      style: {
        cssClass: 'text-grey fill-current',
      },
      datetimeFormatter: {
        year:  'yyyy',
        month: 'MMM \'yy',
        day:   'dd',
        hour:  'HH:mm',
      },
    },
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
  },
  yaxis: {
    grid: {
      padding: {
        left:  0,
        right: 0,
      },
    },
    forceNiceScale: true,
    tickAmount:     4,
    labels:         {
      style: {
        cssClass: 'text-grey fill-current text-13 leading-20',
      },
      formatter(val) {
        const roundedValue = Math.round(val * 10) / 10;
        return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      },
    },
  },
  tooltip: {
    x: { show: false },
  },
});

export default {
  leads: {
    chartOptions: basicSettings(),
  },
  views: {
    series: [{
      name: 'Просмотры',
      data: [
        { x: '2020-01-01', y: 145 },
        { x: '2020-01-02', y: 200 },
        { x: '2020-01-03', y: 100 },
        { x: '2020-01-04', y: 412 }],
    }],
    chartOptions: basicSettings('#34a2e9', '#146fcf'),
  },
};
